<form #f="ngForm" class="fx-row fx-align-end fx-flex-1 fx-gap-10">
  <av-control-row type="text" label="{{ keyLabel() }}" class="fx-flex-1">
    <div class="fx-row fx-flex-1 fx-gap-sm">
      <input
        required
        avInput
        #keyRef="ngModel"
        name="key"
        [(ngModel)]="item().key"
        (ngModelChange)="update()"
        type="text"
        data-tid="metadata/key"
      />
      @if (keyRef.touched && keyRef.hasError('required')) {
      <div translate class="form-error">Required</div>
      }
    </div>
  </av-control-row>

  <av-control-row type="text" label="{{ valueLabel() }}" class="fx-flex-2">
    <div class="fx-row fx-flex-1 fx-gap-sm">
      <input
        required
        avInput
        #valueRef="ngModel"
        name="value"
        [(ngModel)]="item().value"
        (ngModelChange)="update()"
        data-tid="metadata/value"
        type="text"
      />
      @if (valueRef.touched && valueRef.hasError('required')) {
      <div translate class="form-error">Required</div>
      }
    </div>
  </av-control-row>

  @if (hasType) {
  <av-control-row type="text" label="Type" class="fx-flex-1">
    <!-- <label class="fx-row fx-align-end fx-gap-10"
      ><span translate>Type</span>
      <ng-content></ng-content>
    </label> -->
    <select
      avInput
      name="type"
      #typeRef="ngModel"
      [(ngModel)]="item().type"
      (ngModelChange)="update()"
    >
      @for (o of types(); track o) {
      <option [ngValue]="o.value" [disabled]="o.disabled">
        {{ o.label }}
      </option>
      }
    </select>
    @if (typeRef.touched && typeRef.hasError('required')) {
    <div translate class="form-error">Required</div>
    }
  </av-control-row>
  }

  <div class="form-item">
    <label>&nbsp;</label>
    <button
      [attr.aria-label]="'Delete pair' | translate"
      avButton
      ofType="icon"
      size="xs"
      color="danger"
      data-tid="metadata/item/remove"
      (click)="remove()"
    >
      <av-icon name="trash"></av-icon>
    </button>
  </div>
</form>
